import { render, staticRenderFns } from "./ConfirmShopper.vue?vue&type=template&id=06f4fead&scoped=true&"
import script from "./ConfirmShopper.vue?vue&type=script&lang=js&"
export * from "./ConfirmShopper.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmShopper.vue?vue&type=style&index=0&id=06f4fead&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f4fead",
  null
  
)

export default component.exports